// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_leaflet-defaulticon-compatibility_src_Icon_Default_compatibility_js-node-a43fe3":"b98710e9597861401a50","src_views_PhotosTab_vue":"da32b0007c468c15b5d5"}[chunkId] + "";
};